let swiperFourSteps = null;

function initSwiperFourSteps() {
  if (window.innerWidth < 768) { 
    if (!swiperFourSteps) {
      swiperFourSteps = new Swiper('.four__steps__slider', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: false,
        speed: 800,
        autoplay: {
            delay: 3000, 
            disableOnInteraction: false,
        },
        pagination: {
          el: ".four__steps-pagination",
          clickable: true,
        },
      });
      
    }
  } else {
    if (swiperFourSteps) {
      swiperFourSteps.destroy(true, true);
      swiperFourSteps = null;
    }
  }
}

initSwiperFourSteps();
window.addEventListener('resize', initSwiperFourSteps);

